import { Field, FieldArray, WrappedFieldArrayProps } from "redux-form";
import { Button } from "rsuite";
import LegacyTrashIcon from "@rsuite/icons/legacy/Trash";
import InputWithLabel from "shared/components/redux-form/InputWithLabel";
import UploadWithPreview from "shared/components/UploadWithPreview";
import { convertFileToBase64 } from "core/utils/Image";
import { StepImage } from "..";
import clsx from "clsx";

// function RenderOptions({
//   fields,
//   setStepImages,
//   stepImages,
// }: WrappedFieldArrayProps<{}> & {
//   setStepImages: React.Dispatch<
//     React.SetStateAction<Record<number, StepImage>>
//   >;
//   stepImages: Record<number, StepImage>;
// }) {
//   const handleUpload = async (files: File[], index: number) => {
//     if (!files.length) return;
//     const file = files[0];
//     const preview = await convertFileToBase64(file);

//     if (preview) {
//       setStepImages((prev) => ({
//         ...prev,
//         [index]: { file, preview },
//       }));

//       const currentStep = fields.get(index) || {};
//       fields.remove(index);
//       fields.insert(index, { ...currentStep, image: file });
//     }
//   };

//   const handleRemove = (index: number) => {
//     const currentStep = fields.get(index);
//     fields.remove(index);
//     fields.insert(index, { ...currentStep, image: null });

//     setStepImages((prev) => ({
//       ...prev,
//       [index]: { file: null, preview: "" },
//     }));
//   };

//   return (
//     <>
//       <div className="custom-field-header">
//         <div className="fragment-title">
//           <div className="section-title">Steps</div>
//         </div>
//         <Button appearance="primary" onClick={() => fields.push("")}>
//           Add Step
//         </Button>
//       </div>

//       {fields.map((opt, idx) => (
//         <>
//           <div className="custom-field-number">{`Step ${idx + 1}`}</div>

//           <div key={idx} className="custom-option-row">
//             <Field
//               name={`${opt}.desc`}
//               component={InputWithLabel}
//               placeholder="Enter Step"
//             />
//             <Button
//               onClick={() => fields.remove(idx)}
//               appearance="subtle"
//               className="delete-option-btn"
//             >
//               <LegacyTrashIcon />
//             </Button>
//           </div>
//           <div className="store-step-banner">
//             <UploadWithPreview
//               onFileChange={(file) => handleUpload(file, idx)}
//               onRemove={() => handleRemove(idx)}
//               value={stepImages[idx]?.preview || ""}
//               label="Step Image"
//               placeholder="Upload Step Image"
//               accept="image/*"
//             />
//           </div>
//         </>
//       ))}
//     </>
//   );
// }

export default function StoreGameInfo({
  fields,
  title,
  setStepImages,
  stepImages,
}: WrappedFieldArrayProps<any> & {
  title?: string;
  setStepImages: React.Dispatch<
    React.SetStateAction<Record<number, StepImage>>
  >;
  stepImages: Record<number, StepImage>;
}) {
  const handleUpload = async (files: File[], index: number) => {
    if (!files.length) return;
    const file = files[0];
    const preview = await convertFileToBase64(file);

    if (preview) {
      setStepImages((prev) => ({
        ...prev,
        [index]: { file, preview },
      }));

      const currentStep = fields.get(index) || {};
      fields.remove(index);
      fields.insert(index, { ...currentStep, image: file });
    }
  };

  const handleRemove = (index: number) => {
    const currentStep = fields.get(index);
    fields.remove(index);
    fields.insert(index, { ...currentStep, image: null });

    setStepImages((prev) => ({
      ...prev,
      [index]: { file: null, preview: "" },
    }));
  };

  return (
    <>
      <div className={clsx("custom-field-header" , "spacing")}>
        <div className="fragment-title">
          <div className="section-title">{title}</div>
        </div>
        <Button appearance="primary" onClick={() => fields.push("")}>
          Add Step
        </Button>
      </div>

      {fields.map((opt, idx) => (
        <>
          <div className="custom-field-number">{`Step ${idx + 1}`}</div>

          <div key={idx} className="custom-option-row">
            <Field
              name={`${opt}.desc`}
              component={InputWithLabel}
              placeholder="Enter Step"
            />
            <Button
              onClick={() => fields.remove(idx)}
              appearance="subtle"
              className="delete-option-btn"
            >
              <LegacyTrashIcon />
            </Button>
          </div>
          <div className="store-step-banner">
            <UploadWithPreview
              onFileChange={(file) => handleUpload(file, idx)}
              onRemove={() => handleRemove(idx)}
              value={stepImages[idx]?.preview || ""}
              label="Step Image"
              placeholder="Upload Step Image"
              accept="image/*"
            />
          </div>
        </>
      ))}
    </>
  );
}
